import { Link } from 'react-router-dom';
import { LegalPage } from '@/components/LegalPage';

export function TermsPage() {
  return (
    <LegalPage
      title="Terms of Service"
      updated="June 18, 2026"
      intro="These terms govern your use of BingeBox, the streaming service operated by Nullify Entertainment."
    >
      <p>
        By creating an account or using BingeBox (the "Service"), you agree to these Terms. If you
        don't agree, please don't use the Service.
      </p>

      <h2>1. Accounts</h2>
      <p>
        You must be at least 13 years old to create an account. You're responsible for keeping your
        login secure and for activity under your account. Provide accurate information, including a
        valid email and date of birth.
      </p>

      <h2>2. Subscriptions &amp; billing</h2>
      <ul>
        <li>Anyone can browse the catalog and watch previews for free. Full episodes require an active subscription.</li>
        <li>
          Plans are billed <strong>monthly</strong> (auto-renewing until cancelled) or as a
          one-time <strong>annual</strong> purchase that does not auto-renew.
        </li>
        <li>Additional simultaneous streams are an optional paid add-on, up to the plan limit.</li>
        <li>
          Payments are processed by <a href="https://stripe.com" target="_blank" rel="noreferrer">Stripe</a>. We never store your card details.
        </li>
        <li>
          You can change your plan, change your stream count, or cancel any time from{' '}
          <Link to="/account">your account</Link>. Monthly cancellations keep access until the end
          of the paid period.
        </li>
      </ul>

      <h2>3. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Copy, record, redistribute, or publicly perform any content from the Service.</li>
        <li>Circumvent DRM, geographic, or access restrictions.</li>
        <li>Share your account in violation of your plan's simultaneous-stream limit.</li>
        <li>Disrupt, attack, or attempt to gain unauthorized access to the Service.</li>
      </ul>

      <h2>4. Content &amp; intellectual property</h2>
      <p>
        All shows on BingeBox are original works owned by Nullify Entertainment, provided in
        Japanese and English audio. Content is licensed to you for personal, non-commercial viewing
        only. Any community submissions you provide via the Dev Forums may be reviewed and, if
        accepted, used in accordance with our review and content policies.
      </p>

      <h2>5. Termination</h2>
      <p>
        We may suspend or terminate accounts that violate these Terms. You may delete your account at
        any time; cancellation and refund handling are described in your account and in our refund
        practices.
      </p>

      <h2>6. Disclaimers &amp; liability</h2>
      <p>
        The Service is provided "as is." To the maximum extent permitted by law, Nullify
        Entertainment is not liable for indirect or incidental damages arising from your use of the
        Service.
      </p>

      <h2>7. Changes</h2>
      <p>
        We may update these Terms. We'll post the new effective date here and, for material changes,
        notify you by email.
      </p>

      <h2>8. Contact</h2>
      <p>
        Questions? Email <a href="mailto:support@gobingebox.com">support@gobingebox.com</a>.
      </p>

      <p className="text-xs text-ink-faint">
        This document is a general template and not legal advice. Have it reviewed by a qualified
        attorney before relying on it.
      </p>
    </LegalPage>
  );
}
